<template>
  
  <v-container class="pl-0">
  
    <!--  {{ dataAll.getStatic('product_pag_layout_switcher','Layout') }} 
     {{ dataAll.getStatic('product_pag_layout_list','list') }}  -->

    <div class="d-flex flex-row-reverse pt-3">
      <v-sheet>
        <v-btn 
          @click="setPAGLayout(false)" 
          icon
          :color="layoutPAGTable ? 'primary' : 'grey'"
        >
          <v-icon>{{ 'mdi-view-list' }}</v-icon>
        </v-btn>
      </v-sheet>
      <v-sheet>
        <v-btn 
          class="mr-2"
          @click="setPAGLayout(false)" 
          icon
          :color="layoutPAGTable ? 'grey' : 'primary' "
        >
          <v-icon>{{ 'mdi-view-grid' }}</v-icon>
        </v-btn>
      </v-sheet>
    </div>


    <div class="pt-5">
      <ClientOnly>
        <ProductResultRaster
          v-show="!layoutPAGTable"
          :pageItem="pageItem"
          :pagData="pagData"
        />
      </ClientOnly>
      <ArticleResultTable
        v-show="layoutPAGTable"
        :pageItem="pageItem"
        :pagData="pagData"
      />
    </div>
  </v-container>

</template>
<script setup>
import { ref, watch } from 'vue';
import ArticleResultTable from "@/components/Products/PAG/ArticleResultTable.vue";
import ProductResultRaster from "@/components/Products/PAG/ProductResultRaster.vue";
import { onMounted, onUpdated, onBeforeUnmount, onBeforeMount } from "vue";
const { mobile, xs,mdAndUp } = useDisplay();
const dataAll = useDataAll();
const layoutPAGTable = ref( true);

onMounted(() => {
  setPAGLayout(true)
})
const props = defineProps({
  header: {
    type: Object,
    default: "",
  },
  results: {
    type: Object,
    default: "",
  },
  pageItem: {
    type: Object,
    default: "",
  },  
  pagData: {
    type: Object,
    default: "",
  }, 
});


function setPAGLayout(init){
  if (import.meta.client){
    // Key voor localStorage
    const STORAGE_KEY_TABLE = 'layoutPAGTable';


    if (!init){
      layoutPAGTable.value = !layoutPAGTable.value
      localStorage.setItem(STORAGE_KEY_TABLE, layoutPAGTable.value);
    } else {
      const localStorageValue = localStorage.getItem(STORAGE_KEY_TABLE)

      layoutPAGTable.value = localStorageValue !== null 
        ? localStorageValue === 'true' 
        : isMobile()
      
    }
    localStorage.setItem(STORAGE_KEY_TABLE, layoutPAGTable.value);
  }
}
</script>